import React, { useState } from "react";
import { Dialog, DialogPanel, DialogBackdrop, DialogTitle } from '@headlessui/react';
import { API_BASE } from "../config";
import { ChevronDownIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { MegaphoneIcon } from '@heroicons/react/24/outline';
import { toast } from "react-toastify";
import { useNotaire } from "../context/NotaireContext";

const itemsSignature = [
  { name: "Suppression de l'affaire", description: "Nous allons supprimer toutes les données de l'affaire", iconColor: "bg-pink-500", icon: XMarkIcon },
  { name: "Evaluation", description: "Nous allons vous envoyer une enquête de satisfaction pour prendre vos retours.", iconColor: "bg-yellow-500", icon: MegaphoneIcon },
];

const itemsRefus = [
  { name: "Suppression de l'affaire", description: "Nous allons supprimer toutes les données de l'affaire", iconColor: "bg-pink-500", icon: XMarkIcon },
];

const itemsChangement = [
  { name: "Suppression de l'affaire", description: "Nous allons supprimer toutes les données de l'affaire", iconColor: "bg-pink-500", icon: XMarkIcon }
];

const itemsAnnulation = [
  { name: "Suppression de l'affaire", description: "Nous allons supprimer toutes les données de l'affaire", iconColor: "bg-pink-500", icon: XMarkIcon }
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Drawer({ isOpen, onClose, id_affaire, type }) {
  const context = useNotaire();
  const [autreRaison, setAutreRaison] = useState(false);
  const [autreRaisonInput, setAutreRaisonInput] = useState("");
  const [raison, setRaison] = useState("");
  const [submitting, setSubmitting] = useState(false); // loader

const handleDeleteAffaire = async () => {
  setSubmitting(true);
  try {
    //http://localhost:5050/api/cloturerAffaire/
    //https://cloterenotaire.onrender.com/api/cloturerAffaire/
    const resp = await fetch(`${API_BASE}/api/cloturerAffaire/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        idAffaire: id_affaire,   // ⚠️ correspond à req.body.idAffaire
        typeAffaire: type,       // ⚠️ correspond à req.body.typeAffaire
        raisonCloture: raison === "autre" ? autreRaisonInput : raison, // ⚠️ correspond à req.body.raisonCloture
         ...(context?.user?.google_maps_url_from_etudes && {
          lienMapsNotaire: context.user.google_maps_url_from_etudes,
        })
      }),
    });

    if (!resp.ok) {
      const txt = await resp.text();
      console.error("Erreur backend cloturerAffaire:", txt);
      throw new Error(txt || "Erreur serveur");
    }

    toast.success("L'affaire a bien été clôturée.");
    setTimeout(() => {
      onClose();
      window.location.href = "/app/affaires";
    }, 2000);
  } catch (error) {
    console.error("Erreur lors de la clôture :", error);
    toast.error("Une erreur s'est produite, veuillez recommencer.");
  } finally {
    setSubmitting(false);
  }
};

  const sendCloturer = (e) => {
    e.preventDefault();
    if (!raison && !autreRaisonInput) return;
    handleDeleteAffaire();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-10">
      <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75" />
      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
            <DialogPanel className="pointer-events-auto w-screen max-w-md transform transition">
              <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                <div className="px-4 sm:px-6">
                  <div className="flex items-start justify-between">
                    <DialogTitle className="text-base font-semibold text-gray-900">
                      Clôturer cette affaire
                    </DialogTitle>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
                      <XMarkIcon className="size-6" />
                    </button>
                  </div>
                </div>
                <div className="relative mt-6 flex-1 px-4 sm:px-6">
                  <form onSubmit={sendCloturer}>
                    <div className="rounded-md bg-slate-50 p-4 mb-3">
                      <p className="text-sm text-slate-700">
                        Toutes les données de cette affaire seront supprimées : documents, honoraires, messages, etc.
                      </p>
                    </div>

                    {!autreRaison ? (
                      <>
                        <label className="mt-2 mb-2 inline-flex gap-2 font-bold">
                          Sélectionnez le motif de clôture
                        </label>
                        <div className="relative">
                          <select
                            value={raison}
                            onChange={(e) => setRaison(e.target.value)}
                            className="w-full rounded-md bg-white py-1.5 pl-3 pr-8 text-sm outline outline-1 outline-gray-300"
                          >
                            <option value="">Sélectionnez votre raison</option>
                            <option value="signature-acte">👍 Les documents notariés ont été signés</option>
                            <option value="refus-pret">Refus de prêt acheteur</option>
                            <option value="changement-notaire">Changement de notaire</option>
                            <option value="affaire-annulee">Affaire annulée</option>
                          </select>
                          <ChevronDownIcon className="pointer-events-none absolute top-2 right-3 size-5 text-gray-500" />
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            setAutreRaison(true);
                            setRaison("autre");
                          }}
                          className="text-sm underline mt-2"
                        >
                          Autre raison
                        </button>
                      </>
                    ) : (
                      <>
                        <label className="mt-2 mb-2 inline-flex gap-2 font-bold">
                          Quelle est la raison ?
                        </label>
                        <input
                          type="text"
                          value={autreRaisonInput}
                          onChange={(e) => setAutreRaisonInput(e.target.value)}
                          required
                          className="input-clotere"
                        />
                        <button
                          type="button"
                          onClick={() => {
                            setAutreRaison(false);
                            setAutreRaisonInput("");
                            setRaison("");
                          }}
                          className="text-sm underline mt-2"
                        >
                          Annuler
                        </button>
                      </>
                    )}

                    <div className="mt-6">
                      {raison === "signature-acte" && <AffichageItems items={itemsSignature} />}
                      {raison === "refus-pret" && <AffichageItems items={itemsRefus} />}
                      {raison === "changement-notaire" && <AffichageItems items={itemsChangement} />}
                      {raison === "affaire-annulee" && <AffichageItems items={itemsAnnulation} />}
                      {raison === "autre" && <AffichageItems items={itemsRefus} />}
                    </div>

                    {raison && (
                      <button
                        type="submit"
                        disabled={submitting}
                        aria-busy={submitting}
                        className={`btn-primary mt-10 inline-flex items-center justify-center ${
                          submitting ? "opacity-60 cursor-not-allowed" : ""
                        }`}
                      >
                        {submitting ? (
                          <>
                            <svg
                              className="animate-spin -ml-1 mr-2 h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              aria-hidden="true"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              />
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                              />
                            </svg>
                            Clôture en cours…
                          </>
                        ) : (
                          "Clôturer cette affaire"
                        )}
                      </button>
                    )}
                  </form>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

function AffichageItems({ items }) {
  return (
    <ul className="mt-6 divide-y divide-gray-200 border-b border-t border-gray-200">
      {items.map((item, idx) => (
        <li key={idx}>
          <div className="flex items-start space-x-3 py-4">
            <span
              className={classNames(
                item.iconColor,
                "inline-flex size-10 items-center justify-center rounded-lg"
              )}
            >
              <item.icon className="size-6 text-white" aria-hidden="true" />
            </span>
            <div className="flex-1">
              <p className="text-sm font-medium text-gray-900">{item.name}</p>
              <p className="text-sm text-gray-500">{item.description}</p>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default Drawer;